import { SplitButton } from "@features/results/Result/SplitButton"
import { Box, Chip, Grid, Stack } from "@mui/material"
import { Node } from "reactflow"

type NodeSelectionActionsProps = {
  selectedNodes: Node[]
  onClearSelectionClick: () => void
  onDeleteNodeClick: (node: Node) => void
  onCompareNodesClick?: () => void
}

const NodeSelectionActions = (props: NodeSelectionActionsProps) => {
  return (
    <Grid container sx={{ mb: 1 }}>
      <Grid item xs={8}>
        <Box sx={{ overflow: "scroll" }}>
          <Stack direction="row" spacing={1} sx={{ flexWrap: "nowrap" }}>
            {props.selectedNodes.map((node: Node) => (
              <Chip
                key={node.id}
                label={node.data?.display?.label || ""}
                sx={{
                  backgroundColor: "#2B2B2B",
                  "& .MuiChip-deleteIcon": { color: "white" },
                  color: "white",
                  borderRadius: "3px !important",
                }}
                variant="filled"
                onDelete={() => props.onDeleteNodeClick(node)}
              />
            ))}
          </Stack>
        </Box>
      </Grid>
      <Grid item xs={4}>
        <Grid container justifyContent="flex-end">
          {props.onCompareNodesClick && (
            <SplitButton
              sx={{
                "& button": {
                  background: "rgba(214,0,42,0.9)",
                  color: "white !important",
                },
                "& button:hover": {
                  backgroundColor: "rgba(214,0,42,1.0)",
                },
                "& button.Mui-disabled": {
                  backgroundColor: "rgba(214,0,42,0.6)",
                  color: "white !important",
                },
              }}
              title="Compare selected nodes"
              instruction="Click each node you want to compare, and then using the node sidebar, choose 'Add to selection'. Then click 'Compare selected nodes' (this button will be enabled)"
              properties={{
                disabled: props.selectedNodes.length < 2 || props.selectedNodes.length > 10,
                onClick: props.onCompareNodesClick,
              }}
            />
          )}
          <SplitButton
            title="Clear Selection"
            instruction="De-select all selected nodes"
            properties={{
              disabled: props.selectedNodes.length < 1,
              onClick: props.onClearSelectionClick,
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NodeSelectionActions
